export const MAX_STARS_COUNT = 5;

export const BUSINESS_UNIT_ID = '5ce54582f81cda0001471550';

export const CARO_TEMPLATE_ID = '53aa8912dec7e10d38f59f36';

export const getTemplateId = (isFourStars = true) => {
  return isFourStars ? '5406e65db0d04a09e042d5fc' : '54ad5defc6454f065c28af8b';
};

export const TRUSTPILOT_URL = 'https://uk.trustpilot.com/review/drive.co.uk';
